module.exports = __webpack_public_path__ + "static/media/announcement_bar_app_2 copy.cc5d4103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/announcement_bar_app_2 copy.png
// module id = 395
// module chunks = 0